import { render, staticRenderFns } from "./ScheduledCard.vue?vue&type=template&id=967ae0f8&"
import script from "./ScheduledCard.vue?vue&type=script&lang=js&"
export * from "./ScheduledCard.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledCard.vue?vue&type=style&index=0&id=967ae0f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports